import React from 'react';
import { ShieldCheck } from '@phosphor-icons/react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#E8E9EB] dark:bg-[#121212]">
      {/* Header */}
      <div className="bg-[#0F172A] border-b-4 border-black py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex items-center gap-4 mb-2">
            <div className="w-12 h-12 bg-[#2B4C6F] border-2 border-white flex items-center justify-center">
              <ShieldCheck size={28} weight="bold" className="text-white" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-black text-white uppercase">Privacy Policy</h1>
              <p className="text-neutral-400">Last updated: January 2025</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white dark:bg-[#0F172A] border-4 border-black shadow-[8px_8px_0px_#2B4C6F] p-6 md:p-8 space-y-8">
          
          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">1. Information We Collect</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed mb-4">
              We collect information that you provide directly to us, including when you create an account, post a job, apply for work, or contact us for support.
            </p>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              This may include your name, email address, phone number, location, professional skills, work experience, and payment information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">2. How We Use Your Information</h2>
            <ul className="space-y-2 text-neutral-700 dark:text-neutral-300">
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                To provide, maintain, and improve our services
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                To connect contractors with workers and vice versa
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                To process payments and prevent fraud
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                To send you updates, notifications, and promotional materials
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                To respond to your comments, questions, and requests
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">3. Information Sharing</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed mb-4">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="space-y-2 text-neutral-700 dark:text-neutral-300">
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                Other users as necessary to facilitate connections (e.g., contractors viewing worker profiles)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                Service providers who assist in our operations
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                Law enforcement when required by law
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">4. Data Security</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">5. Your Rights</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="space-y-2 text-neutral-700 dark:text-neutral-300">
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                Access your personal information
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                Correct inaccurate information
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                Delete your account and associated data
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2B4C6F] font-bold">•</span>
                Opt out of marketing communications
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase mb-3 pb-2 border-b-2 border-black">6. Contact Us</h2>
            <p className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@constructhelp.com" className="text-[#2B4C6F] hover:underline font-bold">
                privacy@constructhelp.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
